import { render, staticRenderFns } from "./editPost.vue?vue&type=template&id=2adf24ba&"
import script from "./editPost.vue?vue&type=script&lang=js&"
export * from "./editPost.vue?vue&type=script&lang=js&"
import style0 from "./editPost.vue?vue&type=style&index=0&id=2adf24ba&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports